(function () {
var root = document.documentElement;
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var main = document.getElementById('MainContent');
(function () {
if (!main || !main.hasAttribute('data-hm-product-handle')) return;
var btn = main.querySelector('.product-information .add-to-cart-button, .product-information button[name="add"], .product-information [type="submit"]');
if (!btn) return;
var titleEl = main.querySelector('.product-information h1');
var priceEl = main.querySelector('.product-information product-price, .product-information .price');
var bar = document.createElement('div');
bar.className = 'hm-sticky-atc';
bar.setAttribute('aria-hidden', 'true');
bar.innerHTML = '<div class="hm-sticky-atc__info"><span class="hm-sticky-atc__name"></span><span class="hm-sticky-atc__price"></span></div><button type="button" class="hm-sticky-atc__btn" tabindex="-1"></button>';
var nameEl = bar.querySelector('.hm-sticky-atc__name'), pEl = bar.querySelector('.hm-sticky-atc__price'), sBtn = bar.querySelector('.hm-sticky-atc__btn');
nameEl.textContent = titleEl ? titleEl.textContent.trim() : '';
function sync() {
if (priceEl) pEl.textContent = priceEl.textContent.replace(/\s+/g, ' ').trim();
var t = btn.textContent.replace(/\s+/g, ' ').trim();
sBtn.textContent = t || 'Add to bag';
sBtn.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
}
sync();
document.body.appendChild(bar);
sBtn.addEventListener('click', function () { btn.click(); });
if (window.MutationObserver) {
var mo = new MutationObserver(sync);
mo.observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
if (priceEl) mo.observe(priceEl, { childList: true, subtree: true, characterData: true });
}
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
var shown = !e.isIntersecting && e.boundingClientRect.top < 0;
bar.classList.toggle('is-visible', shown);
bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
sBtn.tabIndex = shown ? 0 : -1;
});
}, { threshold: 0 }).observe(btn);
}
})();
if (reduce || !('IntersectionObserver' in window) || !main) return;
root.classList.add('hm-reveal-on');
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); } });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
function mark(el, delay) {
if (!el || el.classList.contains('hm-reveal')) return;
var r = el.getBoundingClientRect();
if (r.top < window.innerHeight * 0.92 && r.bottom > 0) return;
el.classList.add('hm-reveal');
if (delay) el.style.transitionDelay = delay + 'ms';
io.observe(el);
}
var sections = main.querySelectorAll('.shopify-section');
for (var i = 0; i < sections.length; i++) {
var sec = sections[i];
if (!sec.querySelector('[class*="hm-"]')) continue;
if (sec.querySelector('.hm-hero, .hm-colhero, .hm-col')) continue;
var items = sec.querySelectorAll('.grid-product, .hm-stl__card, .hm-quote, .hm-craft__cell');
if (items.length) {
mark(sec.querySelector('.hm-eyebrow, .hm-title, .hm-stl__media'), 0);
for (var j = 0; j < items.length; j++) mark(items[j], (j % 3) * 120);
} else { mark(sec.firstElementChild || sec, 0); }
}
window.setTimeout(function () {
var left = document.querySelectorAll('.hm-reveal:not(.is-in)');
for (var k = 0; k < left.length; k++) { var b = left[k].getBoundingClientRect(); if (b.top < window.innerHeight) left[k].classList.add('is-in'); }
}, 2500);
document.addEventListener('shopify:section:load', function (e) {
var t = e.target; if (!t) return;
t.querySelectorAll('.hm-reveal').forEach(function (el) { el.classList.add('is-in'); });
});
})();
